const hoverTargets = document.querySelectorAll('.hover-target');
const hoverTriggers = document.querySelectorAll('.hover-trigger');
const hoverArrows = document.querySelectorAll('.js-hover-arrow');

hoverTargets.forEach((hoverTarget, index) => {
    const hoverTrigger = hoverTriggers[index];
    const hoverArrow = hoverArrows[index];

    hoverTarget.addEventListener('mouseover', () => {
        hoverTrigger.style.backgroundColor = '#AA4F82';
        hoverTrigger.style.color = 'white';
        hoverArrow.style.color = 'white';
    });

    hoverTarget.addEventListener('mouseout', () => {
        hoverTrigger.style.backgroundColor = '';
        hoverTrigger.style.color = '';
        hoverArrow.style.color = '';
    });
});